import styled from "styled-components";

import { FontSize, Text } from "../../../../components/Text";
import { Rounded } from "../../../../theme/Rounded";
import { Shadow } from "../../../../theme/Shadow";
import { Spacing } from "../../../../theme/Spacing";

/** `$tall` spans two grid rows; only a card whose content can grow into the
 * extra height (the form preview) should ask for it */
export const SetupCard = styled.section<{
  $featured?: boolean;
  $tall?: boolean;
  $done?: boolean;
}>`
  position: relative;
  display: flex;
  flex-direction: column;
  gap: ${Spacing.s};
  min-width: 0;
  overflow: hidden;
  padding: ${({ $featured }) => ($featured ? Spacing.l : Spacing.m)};
  border-radius: ${Rounded.xl};
  background-color: ${({ theme }) => theme.white};
  box-shadow: ${Shadow.SM};
  border: 2px solid
    ${({ theme, $featured, $done }) =>
      $done ? theme.success : $featured ? theme.main : theme.transparent};
  grid-row: ${({ $tall }) => ($tall ? "span 2" : "auto")};
`;

export const SetupCardEyebrow = styled(Text)`
  font-size: ${FontSize.xs};
  font-weight: bold;
  letter-spacing: 0.08em;
  text-transform: uppercase;
  color: ${({ theme }) => theme.main};
`;

export const SetupCardTitle = styled(Text)<{
  $featured?: boolean;
  $done?: boolean;
}>`
  padding-inline-end: ${({ $done }) => ($done ? "4.5rem" : "0")};
  font-size: ${({ $featured }) => ($featured ? FontSize.xl : FontSize.l)};
  font-weight: bold;
  line-height: 1.25;
  color: ${({ theme }) => theme.textColor};
`;

export const SetupCardDescription = styled(Text)<{ $done?: boolean }>`
  padding-inline-end: ${({ $done }) => ($done ? "3rem" : "0")};
  color: ${({ theme }) => theme.darkerSub};
`;

export const SetupCardActions = styled.div<{ $center?: boolean }>`
  display: flex;
  gap: ${Spacing.s};
  flex-wrap: wrap;
  align-items: center;
  justify-content: ${({ $center }) => ($center ? "center" : "flex-start")};

  & > button {
    margin: 0;
  }

  margin-top: auto;
  padding-top: ${Spacing.s};
`;
